// Estado → tono + icono, en un solo lugar.
//
// Hoy `getStatusColor` (orderConstants.js) devuelve nombres de color de
// Bootstrap ('warning', 'info'…) que se pintan como <Badge> sólidos. El
// diseño nuevo usa chips en tinte claro con borde e icono.
//
// `getStatusColor` puede quedarse mientras haya pantallas sin migrar.

export const ORDER_STATUS_META = {
  CREATED:          { tone: 'neutral', icon: 'ri-box-3-line' },
  PENDING_PROOF:    { tone: 'info',    icon: 'ri-file-text-line' },
  PENDING_APPROVAL: { tone: 'warning', icon: 'ri-time-line' },
  PROCESSING:       { tone: 'warning', icon: 'ri-loader-4-line' },
  SHIPPED:          { tone: 'info',    icon: 'ri-send-plane-line' },
  PAID:             { tone: 'success', icon: 'ri-checkbox-circle-line' },
  DELIVERED:        { tone: 'success', icon: 'ri-truck-line' },
  CANCELLED:        { tone: 'danger',  icon: 'ri-close-circle-line' },
};

const NEUTRAL = { tone: 'neutral', icon: 'ri-circle-line' };

export const getStatusMeta = (status) =>
  ORDER_STATUS_META[String(status || '').toUpperCase()] || NEUTRAL;

/** ¿Está pagada? Tres estados, no dos: sí / no / cancelada. */
export const getPaidMeta = (order) => {
  if (order?.status === 'CANCELLED') return { tone: 'danger', label: '—' };
  return order?.is_paid
    ? { tone: 'success', label: 'Sí' }
    : { tone: 'warning', label: 'No' };
};

/** Bono influencer / regalía de un miembro de la red. */
export const getFlagMeta = (isOn) =>
  isOn
    ? { tone: 'success', icon: 'ri-checkbox-circle-line', label: 'Activo' }
    : { tone: 'neutral', icon: 'ri-close-circle-line',    label: 'Inactivo' };

/** Severidad de una alerta crítica. */
export const getSeverityTone = (severity) =>
  ({ CRITICAL: 'danger', HIGH: 'warning', MEDIUM: 'info', LOW: 'neutral' }[
    String(severity || '').toUpperCase()
  ] || 'neutral');
